import { AnimatePresence, motion } from "framer-motion";
import moment from "moment";
import { useRef, useState } from "react";
import Card from "src/components/Card";
import Calendar from "src/components/field/utils/Calendar";
import Icon from "src/components/field/utils/Icon";
import Wrapper, { WrapperProps } from "src/components/field/utils/Wrapper";
import useBlur from "src/hooks/useBlur";
import useElementSize from "src/hooks/useElementSize";
import { useKeyPress } from "src/hooks/useKeyPress";
import useWindowSize from "src/hooks/useWindowSize";

const animations = {
	initial: {
		y: -20,
		scale: 0.8,
		opacity: 0,
	},
	animate: {
		y: 0,
		scale: 1,
		opacity: 1,
	},
};

interface DateProps {
	wrapper: WrapperProps;
	value: string;
	onChange: (value: string) => void;
	calendar?: {
		visible?: boolean;
		disabled?: boolean;
	};
}

const Date = ({ wrapper, value, onChange, calendar }: DateProps) => {
	const inputWrapper = useElementSize();
	const { isPhone } = useWindowSize();
	const calendarRef: any = useRef();
	const [showCalendar, setShowCalendar] = useState(calendar?.visible);
	const input: any = useRef();
	useKeyPress(["Escape"], () => {
		setShowCalendar(false);
	});
	useBlur(calendarRef, () => {
		setShowCalendar(false);
	});

	const getInputValue = () => {
		if (!value) return undefined;

		return moment.utc(value, "YYYY-MM-DD").toISOString().substring(0, 10);
	};

	const onIconClick = () => {
		if (!showCalendar) {
			setShowCalendar(!showCalendar);
		}
	};

	return (
		<Wrapper
			{...{
				...wrapper,
				onFocus: () => input?.current?.focus(),
			}}
		>
			<div className="relative">
				<div
					ref={inputWrapper.ref}
					onClick={() => {
						if (isPhone) {
							setShowCalendar(true);
						}
					}}
					className="flex items-center relative gap-2 border-[2px] border-transparent p-1"
				>
					{!calendar?.disabled && (
						<Icon onClick={onIconClick} icon="far fa-calendar" />
					)}
					{!isPhone ? (
						<input
							className={`hide-date-icon bg-transparent flex-1 ${
								value ? "" : "text-placeholder"
							}`}
							ref={input}
							type="date"
							value={getInputValue()}
							onChange={(e) => {
								onChange(
									moment(e.target.value).format("YYYY-MM-DD")
								);
							}}
						/>
					) : (
						<span className={`${value ? "" : "text-placeholder"}`}>
							{value
								? moment(value).format("DD-MM-YYYY")
								: "dd-mm-jjjj"}
						</span>
					)}
				</div>

				<AnimatePresence>
					{showCalendar && (
						<motion.div
							initial={animations.initial}
							exit={animations.initial}
							animate={animations.animate}
							className="absolute z-[20]"
							ref={calendarRef}
						>
							<Card
								className="w-max mt-2"
								contentClassName=" p-0 "
							>
								<Calendar
									value={value || ""}
									onChange={(value) => {
										setShowCalendar(false);
										// onChange(value);
										onChange(
											moment(value).format("YYYY-MM-DD")
										);
									}}
								/>
							</Card>
						</motion.div>
					)}
				</AnimatePresence>
			</div>
		</Wrapper>
	);
};

export default Date;
